export default "<div class=\"typeacces\">\n  {{ TypeAccesInComponent.Identifiant }}\n</div>\n";